import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "exclamationcircleo",
  "use": "exclamationcircleo-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"exclamationcircleo\"><title>exclamationcircleo</title><path d=\"M8 1.125q1.406 0 2.672.531 1.234.531 2.188 1.484t1.469 2.188q.547 1.266.547 2.672t-.531 2.672q-.531 1.234-1.484 2.188t-2.188 1.469q-1.266.547-2.672.547t-2.672-.531q-1.234-.531-2.188-1.484t-1.469-2.188q-.547-1.266-.547-2.672t.531-2.672q.531-1.234 1.484-2.188t2.188-1.469Q6.594 1.125 8 1.125zM8 0Q5.828 0 3.984 1.07T1.07 3.984 0 8t1.07 4.016 2.914 2.914T8 16t4.016-1.07 2.914-2.914T16 8t-1.07-4.016-2.914-2.914T8 0zm0 10q-.266 0-.445-.18t-.18-.445V3.609q0-.266.18-.445T8 2.984t.445.18.18.445v5.766q0 .266-.18.445T8 10zm-.703 1.703q0-.297.203-.5T8 11t.5.203.203.5-.203.5-.5.203-.5-.203-.203-.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/exclamationcircleo.svg
// module id = 160
// module chunks = 0